import React, { useEffect, useContext } from "react";
import { ThemeContext } from "../context/ThemeContextManagement";

const DetectTouch = () => {
  const { touch, touchFired, setTouch, setTouchFired } =
    useContext(ThemeContext);

  useEffect(() => {
    // Set initial touch capability
    const isTouchCapable =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    setTouch(isTouchCapable);
    document.documentElement.classList.add(
      isTouchCapable ? "state-touch" : "state-no-touch"
    );

    const handleMouseMove = () => {
      if (!touchFired && touch) {
        setTouch(false);
        document.documentElement.classList.remove("state-touch");
        document.documentElement.classList.add("state-no-touch");
      }
    };

    const handleTouchStart = () => {
      if (!touchFired) {
        setTouchFired();
        document.documentElement.classList.remove("state-no-touch");
        document.documentElement.classList.add("state-touch");
      }
    };

    document.documentElement.addEventListener("touchstart", handleTouchStart, {
      once: true,
    });
    window.addEventListener("mousemove", handleMouseMove, { once: true });

    return () => {
      document.documentElement.removeEventListener(
        "touchstart",
        handleTouchStart
      );
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []); // Empty dependency array - only run once on mount

  return null;
};

export default DetectTouch;
